module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex",
    staticStyle: {
      "padding-bottom": "0"
    }
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.orderNo),
      expression: "pageInfo.orderNo"
    }],
    staticClass: "center-input fs-20",
    attrs: {
      "type": "search",
      "placeholder": "搜索订单号"
    },
    domProps: {
      "value": (_vm.pageInfo.orderNo)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "orderNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-28",
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orgInf.orgName),
      expression: "orgInf.orgName"
    }],
    staticClass: "in-txt v-picker center-input fs-20",
    attrs: {
      "type": "search",
      "placeholder": "选择小区"
    },
    domProps: {
      "value": (_vm.orgInf.orgName)
    },
    on: {
      "focusin": function($event) {
        _vm.showPicker = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.orgInf, "orgName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n                搜索\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-state"
  }, [_c('van-tabs', {
    attrs: {
      "swipeable": "",
      "swipe-threshold": 5,
      "line-width": '.6rem'
    },
    on: {
      "click": _vm.tabClick
    },
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, _vm._l((_vm.tabList), function(item, $index) {
    return _c('van-tab', {
      key: $index,
      attrs: {
        "title": item.title,
        "name": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel "
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, [_c('ul', {
    staticClass: "pt-10"
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "flex-center click"
    }, [_c('div', {
      staticClass: "alifont pd-20 fs-48",
      class: item.selected ? 'icon-xuanzhong color-main' : 'icon-weixuanzhong color-999',
      on: {
        "click": function($event) {
          return _vm.chooseOrder(item, $index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "order-item flex1 ofh",
      on: {
        "click": function($event) {
          _vm.getScrollerPosition();
          _vm.$router.push({
            name: 'orderDetail',
            query: {
              orderId: item.orderId
            }
          })
        }
      }
    }, [_c('div', {}, [_c('div', {
      staticClass: "flex-center address-box"
    }, [_c('div', {
      staticClass: "alifont icon-dizhi"
    }), _vm._v(" "), _c('div', {
      staticClass: "flex1"
    }, [_c('div', {
      staticClass: "fs-28 color-333"
    }, [_vm._v(_vm._s(item.userAddress))]), _vm._v(" "), _c('div', {
      staticClass: "flex fs-28 color-999 mt-5"
    }, [_c('div', {
      staticClass: "mr-30"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.userMobile))])])])])]), _vm._v(" "), (item.transportTime) ? _c('div', {
      staticClass: "flex-between fs-28 pd-250 bd-top"
    }, [_c('div', {
      staticClass: "color-999"
    }, [_vm._v("期望送达时间")]), _vm._v(" "), _c('div', {
      staticClass: "color-main"
    }, [_vm._v(_vm._s(item.transportTime))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product-list"
    }, [(item.productList.length == 1) ? _c('div', _vm._l((item.productList), function(prod, prodIndex) {
      return _c('div', {
        key: prodIndex,
        staticClass: "product-item flex-center pd-100"
      }, [_c('div', {
        staticClass: "product-img"
      }, [_c('img', {
        attrs: {
          "src": prod.imgPathView,
          "alt": ""
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "product-info flex1 ofh"
      }, [_c('div', {
        staticClass: "fs-24 color-000 text-el mt-5"
      }, [_vm._v(_vm._s(prod.productName))]), _vm._v(" "), (prod.specName) ? _c('div', {
        staticClass: "fs-22 color-999 mt-5"
      }, [_vm._v(_vm._s(prod.specName))]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "flex-between fs-24 color-999 mt-8"
      }, [_c('div', [_vm._v("¥" + _vm._s(prod.salePrice))]), _vm._v(" "), _c('div', [_vm._v("x" + _vm._s(prod.productQty))])])])])
    }), 0) : _c('div', {
      staticClass: "flex-between flex-center"
    }, [_c('div', {
      staticClass: "product-item-img-box flex-center"
    }, _vm._l((item.productList), function(prod, prodIndex) {
      return (prodIndex < 4) ? _c('div', {
        key: prodIndex,
        staticClass: "product-img mr-10"
      }, [_c('img', {
        attrs: {
          "src": prod.imgPathView,
          "alt": ""
        }
      })]) : _vm._e()
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "fs-24 color-999"
    }, [_vm._v("共" + _vm._s(item.productList.length || 0) + "件")])])]), _vm._v(" "), _c('div', {
      staticClass: "pd-250 fs-28 color-999"
    }, [_c('div', {
      staticClass: "flex-center flex-between fs-26"
    }, [_c('div', [_vm._v("订单号：" + _vm._s(item.orderNo))]), _vm._v(" "), _c('div', {
      class: item.printState == '1' ? 'color-main' : 'color-333'
    }, [_vm._v(_vm._s(item.printState == '1' ? '已打印' : '未打印'))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-8 flex-between fs-26"
    }, [_c('div', [_vm._v("下单时间：" + _vm._s(new Date(item.orderCommitTime.replace(/-/g, '/')).Format('MM-dd hh:mm')))]), _vm._v(" "), _c('div', [_vm._v("合计："), _c('span', {
      staticClass: "color-333"
    }, [_vm._v("¥" + _vm._s(item.receivable))])])]), _vm._v(" "), (item.dmMobile || item.dmName) ? _c('div', {
      staticClass: "fs-26 flex-between mt-8"
    }, [_c('div', [_vm._v("配送员："), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.dmName))])]), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.makeCall(item.dmMobile)
        }
      }
    }, [_vm._v("联系方式："), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.dmMobile))])])]) : _vm._e(), _vm._v(" "), (item.remark) ? _c('div', {
      staticClass: "mt-8 bd-top pt-25 "
    }, [_vm._v("备注："), _c('span', {
      staticClass: "color-333"
    }, [_vm._v(_vm._s(item.remark))])]) : _vm._e()])])])
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-fixed-bot"
  }, [_c('div', {
    staticClass: "flex-center flex1 click",
    on: {
      "click": function($event) {
        return _vm.chooseAll()
      }
    }
  }, [_c('div', {
    staticClass: "alifont fs-48",
    class: _vm.isChooseAll ? 'icon-xuanzhong color-main' : 'icon-weixuanzhong color-999'
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-30 color-333 ml-20"
  }, [_vm._v("全选")])]), _vm._v(" "), _c('div', {
    staticClass: "btn gray click",
    on: {
      "click": _vm.printOrderNet
    }
  }, [_vm._v("打印订单")]), _vm._v(" "), _c('div', {
    staticClass: "btn green click",
    on: {
      "click": _vm.sendOrder
    }
  }, [_vm._v("发货")])]), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions,
      "cancel-text": "取消",
      "close-on-click-action": "",
      "description": "请选择发货类型"
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.actionsSheetShow),
      callback: function($$v) {
        _vm.actionsSheetShow = $$v
      },
      expression: "actionsSheetShow"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.expressPopShow),
      callback: function($$v) {
        _vm.expressPopShow = $$v
      },
      expression: "expressPopShow"
    }
  }, [(_vm.expressPopShow) ? _c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "title": "选择物流",
      "columns": _vm.dicts['express_type'] || [],
      "value-key": "codename",
      "default-index": _vm.expressDefaultIndex
    },
    on: {
      "cancel": function($event) {
        _vm.expressPopShow = false
      },
      "confirm": _vm.onExpressConfirm
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.columns,
      "value-key": "orgName"
    },
    on: {
      "confirm": _vm.onConfirm,
      "cancel": _vm.onCancel
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-923280b6","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/order/waitSendOrderList.vue
// module id = H9Ne
// module chunks = 51